import React, { forwardRef, ComponentClass, MutableRefObject } from 'react';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import { Add } from './add';
import { Summary } from './summary';

export type ReactionsProps = ClassNamePropsWithChildren<
  React.ElementType<HTMLDivElement>
>;

type Ref<T> =
  | ((instance: T | null) => void)
  | MutableRefObject<T | null>
  | null;

type ReactionsType = ComponentClass<ReactionsProps> & {
  Summary: typeof Summary;
  Add: typeof Add;
};

const Reactions: ReactionsType = forwardRef(
  (props: ReactionsProps, ref: Ref<HTMLDivElement>) => {
    const { children, ...rest } = props;

    return (
      <div ref={ref} {...rest}>
        {props.children}
      </div>
    );
  },
) as unknown as ReactionsType;

Reactions.Summary = Summary;
Reactions.Add = Add;

export { Reactions };
